"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildComparisonLineLabelAccessor = exports.buildFirstThresholdTimestampAccessor = exports.buildFirstThresholdMeasureAccessor = void 0;
var getters_1 = require("./getters");
var engine_1 = require("../../engine");
var numberFormatter_1 = require("../../formatting/numberFormatter");
var Accessor_1 = require("../../models/Accessor");
var metricValue_1 = require("../metricValue");
var models_1 = require("./models");
function buildFirstThresholdMeasureAccessor(effectiveDefinition) {
    var feature = (0, getters_1.getThresholdFeature)(effectiveDefinition.features);
    var line = (0, getters_1.getDefaultLineForThreshold)(feature);
    if (!line) {
        return undefined;
    }
    return (0, Accessor_1.accessorForReference)(line.measure);
}
exports.buildFirstThresholdMeasureAccessor = buildFirstThresholdMeasureAccessor;
var buildFirstThresholdTimestampAccessor = function (effectiveDefinition) {
    var feature = (0, getters_1.getThresholdFeature)(effectiveDefinition.features);
    var line = (0, getters_1.getDefaultLineForThreshold)(feature);
    if (!(line === null || line === void 0 ? void 0 : line.timestamp)) {
        return undefined;
    }
    return (0, Accessor_1.accessorForReference)(line.timestamp);
};
exports.buildFirstThresholdTimestampAccessor = buildFirstThresholdTimestampAccessor;
var buildComparisonLineLabelAccessor = function (definition, table) {
    var labelType = (0, getters_1.getLineStyleForDefaultThresholdLine)(definition);
    switch (labelType === null || labelType === void 0 ? void 0 : labelType.lineLabel) {
        case models_1.LineLabelStyle.LATEST_VALUE:
            var comparisonAccessor_1 = buildFirstThresholdMeasureAccessor(definition);
            if (!comparisonAccessor_1) {
                return undefined;
            }
            var latestComparisonPoint = (0, engine_1.getLatestValue)(table, comparisonAccessor_1);
            if (!latestComparisonPoint) {
                return undefined;
            }
            var timestampAccessor_1 = (0, metricValue_1.buildTimestampAccessor)(definition);
            var formatString_1 = (0, metricValue_1.getMeasureFormatString)(definition);
            var latestComparisonTimestamp_1 = timestampAccessor_1(latestComparisonPoint);
            var MAX_CHARACTERS_1 = 6;
            return function (row) {
                if (timestampAccessor_1(row) === latestComparisonTimestamp_1) {
                    return (0, numberFormatter_1.formatValueAsMetricNumber)(comparisonAccessor_1(row), formatString_1, MAX_CHARACTERS_1);
                }
                else {
                    return undefined;
                }
            };
        case models_1.LineLabelStyle.NONE:
        case undefined:
        default:
            return undefined;
    }
};
exports.buildComparisonLineLabelAccessor = buildComparisonLineLabelAccessor;
//# sourceMappingURL=buildAccessors.js.map